// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { WishListCollectionModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import { BuyingList } from "@store/Framework/Services/RestrictedBuyingListService";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

export interface BuyingListApiParameter {
    page: number;
    pageSize: number;
    query: string;
    sort?: string;
}
export type BuyingListState = ApplicationState["bunzl"]["pages"]["buyingList"];
export const initialBuyingListState: BuyingListState = {
    buyingLists: undefined,
    assignedBuyingList: {},
    activeBuyingList: undefined,
    activeWishList: undefined,
    isLoading: false,
    apiParams: {
        page: 1,
        pageSize: 9,
        query: "",
    },
};

const buyingListActions = {
    "Stores/Pages/buyingList/ResetState": (draft: Draft<BuyingListState>) => {
        return initialBuyingListState;
    },

    "Store/Pages/buyingList/setIsLoading": (draft: Draft<BuyingListState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "Store/Pages/buyingList/setApiParams": (
        draft: Draft<BuyingListState>,
        action: { apiParams: { page: number; pageSize: number; query: string; sort?: string } },
    ) => {
        draft.apiParams = action.apiParams;
    },
    "Stores/Pages/buyingList/LoadActiveWishList": (
        draft: Draft<BuyingListState>,
        action: { activeWishList: WishListModel },
    ) => {
        draft.activeWishList = action.activeWishList;
    },
    "Stores/Pages/buyingList/LoadActiveBuyingList": (
        draft: Draft<BuyingListState>,
        action: { activeBuyingList: BuyingList },
    ) => {
        draft.activeBuyingList = action.activeBuyingList;
    },

    "Store/Pages/buyingList/LoadBuyingList": (
        draft: Draft<BuyingListState>,
        action: { buyingLists: WishListCollectionModel },
    ) => {
        draft.buyingLists = action.buyingLists;
    },
    "Store/Pages/buyingList/LoadAssignedBuyingList": (
        draft: Draft<BuyingListState>,
        action: { assignedBuyingList: { [key: string]: string[] } },
    ) => {
        draft.assignedBuyingList = action.assignedBuyingList;
    },
};

const buyingListReducer = createTypedReducerWithImmer(initialBuyingListState, buyingListActions);
export type BuyingListActions = BunzlActionUnion<typeof buyingListActions>;
export default buyingListReducer;
